<svelte:options accessors/>
<script lang="ts">
    import NauiSlideOver from "../../naui/layout/NauiSlideOver.svelte";
    import NauiTabs from "../../naui/components/NauiTabs.svelte";
    export let openSlideoverImagenes;
    export let tabsImagenes;
    export let activeImageTab;
</script>

<NauiSlideOver title="Imágenes" bind:open={openSlideoverImagenes}>
    <NauiTabs bind:activeTab={activeImageTab} tabs={tabsImagenes}/>
    {#each tabsImagenes as tab (tab.slug)}
        {#if tab.slug === activeImageTab}
            <div class="py-15">
                {#if tab.images.length > 0}
                    {#each tab.images as image, i}
                        <div class="mb-1">
                            <img src={image.src} alt={image.name}/>
                        </div>
                    {/each}
                {:else}
                    <div>No se han cargado imagenes en esta sección</div>
                {/if}
            </div>
        {/if}
    {/each}
</NauiSlideOver>
